import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { COLORS_ADMIN_PAGE } from '../../conf/constants';

interface ErrorStateProps {
  title?: string;
  message: string;
  onRetry?: () => void;
  height?: string | number;
}

const ErrorState: React.FC<ErrorStateProps> = ({
  title = "Error",
  message,
  onRetry,
  height = '50vh'
}) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height }}>
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="h6" sx={{ color: 'error.main', mb: 2 }}>
          {title}
        </Typography>
        <Typography variant="body2" sx={{ color: COLORS_ADMIN_PAGE.TEXT_SECONDARY, mb: 2 }}>
          {message}
        </Typography>
        {onRetry && (
          <Button
            variant="contained"
            onClick={onRetry}
            sx={{
              bgcolor: COLORS_ADMIN_PAGE.PRIMARY,
              '&:hover': { bgcolor: COLORS_ADMIN_PAGE.PRIMARY }
            }}
          >
            Retry
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default ErrorState;